import { Collapse, Descriptions } from 'antd';
import React from 'react';
import styled from 'styled-components';

const StyledCollapse = styled(Collapse)`
  border-radius: 4px;
  background: transparent;
  .ant-collapse-content {
    border-top: none;
  }
  .ant-collapse-header {
    color: var(--Text-text-600, #232b3a);
    /* Body/Body 2 - Medium */
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
    letter-spacing: 0.028px;
  }
`;
const DescriptionWithCollapse = ({
  name,
  title,
  items,
  descriptionProps,
  collapseProps,
  panelProps,
  children,
  className,
  defaultActive = [],
}) => {
  return (
    <StyledCollapse
      className={className}
      defaultActiveKey={[name, ...defaultActive]}
      expandIconPosition="end"
      {...collapseProps}>
      <Collapse.Panel header={title} key={name} {...panelProps}>
        <Descriptions {...descriptionProps}>
          {items.map((descriptionItem, index) => {
            return <Descriptions.Item key={index} {...descriptionItem} />;
          })}
        </Descriptions>
      </Collapse.Panel>
      {children}
    </StyledCollapse>
  );
};

const Description = ({items=[],...props}) => {
  return <Descriptions {...props} >
  {items.map((descriptionItem, index) => {
    return <Descriptions.Item key={index} {...descriptionItem} />;
  })}</Descriptions>
};
Description.WithCollapse = DescriptionWithCollapse;

export default Description;
